/**
 * Ryan O'Dowd
 * 2024-12-07
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({colors}) => {
  return {
    container: {
      overflow: 'hidden',
      borderRadius: 2,
      height: 16,
      marginBottom: 4,
      backgroundColor: colors.extraLightGray,
      opacity: 0.4,
    },
    skeleton: {
      height: '100%',
      backgroundColor: colors.lightGray,
    },
  };
};

export default getStyles;
